export default __webpack_public_path__ + "static/eVerify_Message-0e699b9ec8d8537e958ba3c4dc37bbc6.pdf";